import HelpLayout from "@/components/layout/HelpLayout";
import ChamadosHistoricoManager from "@/components/pages/chamados/ChamadosHistoricoManager";
import HelpNavigationTabs from "@/components/ui/help-navigation-tabs";
import PendenciaCard from "@/components/ui/pendencia-card";

export default function HistoricoDeChamadosPage() {
  return (
    <HelpLayout title="Histórico de chamados">
      <div className="w-full overflow-hidden">
        <PendenciaCard mode="screen" screenName="FAQ / Suporte" />

        <div className="mt-6 w-full overflow-hidden rounded-2xl border border-gray-200 bg-white p-3 shadow-sm sm:p-6">
          <HelpNavigationTabs className="mb-4 sm:mb-6" />

          <ChamadosHistoricoManager />
        </div>
      </div>
    </HelpLayout>
  );
}
